"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeValByCondition = exports.themeColorPropOr = exports.themeColorProp = exports.themeValByPropKeyOr = exports.themeValByPropKey = exports.themeValLookup = void 0;

var _dotProp = _interopRequireDefault(require("dot-prop"));

var _function = require("./function");

var lookupThemeVal = function lookupThemeVal(theme, key) {
  return _dotProp["default"].get(theme, key);
};

var themeValLookup = function themeValLookup(themeKey) {
  return function (props) {
    if (!props || !props.theme || !themeKey) return undefined;
    return lookupThemeVal(props.theme, themeKey);
  };
};

exports.themeValLookup = themeValLookup;

var themeValByPropKey = function themeValByPropKey(propKey) {
  return function (props) {
    if (!props || !props[propKey]) return undefined;
    return themeValLookup(props[propKey])(props);
  };
};

exports.themeValByPropKey = themeValByPropKey;

var themeValByPropKeyOr = function themeValByPropKeyOr(propKey, fallBackThemeKey) {
  return function (props) {
    var val = themeValByPropKey(propKey)(props);
    return val || themeValLookup(fallBackThemeKey)(props);
  };
};

exports.themeValByPropKeyOr = themeValByPropKeyOr;

var themeColorProp = function themeColorProp() {
  return function (props) {
    if (!props || !props.color) return undefined;
    var colorPropVal = props.color;

    if (!colorPropVal.startsWith('color.')) {
      colorPropVal = "color.".concat(props.color);
    }

    return themeValLookup(colorPropVal)(props);
  };
};

exports.themeColorProp = themeColorProp;

var themeColorPropOr = function themeColorPropOr(defaultThemeColorKey) {
  return function (props) {
    var val = themeColorProp()(props);

    if (!val && !!defaultThemeColorKey) {
      var colorPropVal = defaultThemeColorKey;

      if (!colorPropVal.startsWith('color.')) {
        colorPropVal = "color.".concat(defaultThemeColorKey);
      }

      return themeValLookup(colorPropVal)(props);
    }

    return val;
  };
}; // Choose themeKeyA if condition is/returns true, else themeKeyB


exports.themeColorPropOr = themeColorPropOr;

var themeValByCondition = function themeValByCondition(themeKeyA, themeKeyB, condition) {
  return function (props) {
    var useKeyA = (0, _function.isFunction)(condition) ? !!condition(props) : !!condition;
    return themeValLookup(useKeyA ? themeKeyA : themeKeyB)(props);
  };
};

exports.themeValByCondition = themeValByCondition;
//# sourceMappingURL=theme.js.map